import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import WelcomeComp from "pages/Dashboard/WelcomeComp";
import UserService from "Api/Services/UserService";
import { Link } from "react-router-dom";

const UserDashboard = props => {

  //meta title
  document.title = "Dashboard | infuseone";
  const [totalAssignedDrugs, setTotalAssignedDrugs] = useState('');
  const [error, setError] = useState('');


  const LoadTotalcount = async () => {
    try {
      const restotalAssignedDrugs = await UserService.totalAssignedDrugs().json();

      if (restotalAssignedDrugs.status) {
        setTotalAssignedDrugs(restotalAssignedDrugs.total);
      }

    } catch (error) {
      setError('Something went wrong');
      return;
    }
  };

  const reports = [
    { title: "Drugs Assigned ", iconClass: "bx-listbx bxs-capsule font-size-18", description: totalAssignedDrugs, url: "/assgined-user-drug-list" },

  ];
  useEffect(() => {
    LoadTotalcount();
  }, []);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}

          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">{props.t("Dashboard")} </h4>
          </div>
          <Row>
            <Col xl="4">
              <WelcomeComp />
            </Col>
            <Col xl="8">
              <Row>
                {reports.map((report, index) => (
                  <Col md="4" key={"_col_" + index}>
                    <Card className="mini-stats-wid commonboxform">
                      <Link to={report.url}>
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h4 className="mb-0">{report.description || 0}</h4>
                            </div>
                            <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i className={"bx " + report.iconClass + " font-size-24"}></i>
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Link>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

// UserDashboard.propTypes = {
//   t: PropTypes.any,
//   chartsData: PropTypes.any,
//   onGetChartsData: PropTypes.func,
// };

export default withTranslation()(UserDashboard);
